const React = require("react");

const GlobalStateContext = React.createContext();
const GlobalDispatchContext = React.createContext();

const initialState = {
  popupFormState: false,
  compareCourses: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case "TOGGLE_POPUPFORM":
      return {
        ...state,
        popupFormState: !state.popupFormState,
      };
    case "SET_COMPARE_COURSES":
      return {
        ...state,
        compareCourses: action.payload,
      };
    case "ADD_COMPARE_COURSE":
      if (state.compareCourses.find((c) => c.id === action.payload.id))
        return state;
      if (state.compareCourses.length >= 5) return state;
      return {
        ...state,
        compareCourses: [...state.compareCourses, action.payload],
      };
    case "REMOVE_COMPARE_COURSE":
      return {
        ...state,
        compareCourses: state.compareCourses.filter(
          (c) => c.slug !== action.payload
        ),
      };
    case "CLEAR_COMPARE_COURSES":
      return {
        ...state,
        compareCourses: [],
      };
    default:
      return state;
  }
};
const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  );
};

module.exports = {
  GlobalStateContext,
  GlobalDispatchContext,
  GlobalContextProvider,
  __esModule: true,
};
